import { lazy } from "react";
import ViewStudentNotification from "@repo/design-system/components/viewStudentNotification/ViewStudentNotification.jsx";

const StudentRecords = lazy(() => import("../pages/studentRecords/StudentRecords"));
const DivisionAssignment = lazy(() => import("../pages/divisionAssignment/DivisionAssignment"));
const DivisionConfiguration = lazy(() => import("../pages/divisionConfiguration/DivisionConfiguration"));
const GovernmentAnnouncement = lazy(() => import("../pages/governmentAnnouncement/GovernmentAnnouncement"));
const AddEditGovAnnouncement = lazy(() => import("../pages/governmentAnnouncement/feature/addEditGovAnnouncement/AddEditGovAnnouncement"));
const OsVersionCompatibility = lazy(() => import("../pages/osVersionCompatibility/OsVersionCompatibility"));
const StudentNotificationManagement = lazy(() => import("../pages/studentNotificationManagement/StudentNotificationManagement"));
const ViewStudentNotificationPage = () => (
    <ViewStudentNotification />
);
const EducationDashboardAnalytics = lazy(() => import("../pages/educationDashboardAnalytics/EducationDashboardAnalytics"));
const StudentPromotionDetention = lazy(() => import("../pages/studentPromotionDetention/StudentPromotionDetention"));
const DetainedStudents = lazy(() => import("../pages/detainedStudents/DetainedStudents"));

const ComponentNavigation = [
    {
        id: "student-records",
        path: "/student-records",
        exact: true,
        title: "",
        component: StudentRecords,
        hasParams: false,
        text: "Student Records",
    },
    {
        id: "division-assignment",
        path: "/division-assignment",
        exact: true,
        title: "",
        component: DivisionAssignment,
        hasParams: false,
        text: "Division Assignment",
    },
    {
        id: "division-configuration",
        path: "/division-configuration",
        exact: true,
        title: "",
        component: DivisionConfiguration,
        hasParams: false,
        text: "Division Assignment",
    },
    {
        id: "government-announcement",
        path: "/government-announcement",
        exact: true,
        title: "",
        component: GovernmentAnnouncement,
        hasParams: false,
        text: "Government Announcement",
    },
    {
        id: "add-edit-gov-announcement",
        path: "/add-edit-gov-announcement",
        exact: true,
        title: "",
        component: AddEditGovAnnouncement,
        hasParams: false,
        text: "Add/Edit Government Announcement",
    },
    {
        id: "os-version-compatibility",
        path: "/os-version-compatibility",
        exact: true,
        title: "OS Version Compatibility Check",
        component: OsVersionCompatibility,
        hasParams: false,
        text: "OS Version Compatibility Check",
    },
    {
        id: "student-notification-management",
        path: "/student-notification-management",
        exact: true,
        title: "Student Notification Management",
        component: StudentNotificationManagement,
        hasParams: false,
        text: "Student Notification Management",
    },
    {
        id: "view-student-notification",
        path: "/view-student-notification",
        exact: true,
        title: "",
        component: ViewStudentNotificationPage,
        hasParams: false,
        text: "View Student Notifications",
    },
    {
        id: "education-dashboard-analytics",
        path: "/education-dashboard-analytics",
        exact: true,
        title: "Education Dashboard Analytics",
        component: EducationDashboardAnalytics,
        hasParams: false,
        text: "Education Dashboard Analytics",
    },
    {
        id: "student-promotion-detention",
        path: "/promotion-detention",
        exact: true,
        title: "",
        component: StudentPromotionDetention,
        hasParams: false,
        text: "Student Promotion / Detention Flow",
    },
    {
        id: "detained-students",
        path: "/detained-students",
        exact: true,
        title: "",
        component: DetainedStudents,
        hasParams: false,
        text: "Detained Students",
    },
];

export default ComponentNavigation;
